export enum EHash {
    ContextMenu = 'ContextMenu',
}
